import {GotchaStatusVo} from '../../common/shared/api/nicolas/vo/enums/GotchaStatusVo.enum';
import {GotchaStatus} from '../generated/types';

export function createGotchaStatus(
  gotchaStatusVo: GotchaStatusVo
): GotchaStatus {
  return mapper[gotchaStatusVo];
}

const mapper: {[key in GotchaStatusVo]: GotchaStatus} = {
  [GotchaStatusVo.Already]: GotchaStatus.Already,
  [GotchaStatusVo.Disable]: GotchaStatus.Disable,
  [GotchaStatusVo.Duplicate]: GotchaStatus.Duplicate,
  [GotchaStatusVo.Error]: GotchaStatus.Error,
  [GotchaStatusVo.Expire]: GotchaStatus.Expire,
  [GotchaStatusVo.Fail]: GotchaStatus.Fail,
  [GotchaStatusVo.First]: GotchaStatus.First,
  [GotchaStatusVo.Noauth]: GotchaStatus.Noauth,
  [GotchaStatusVo.TicketFail]: GotchaStatus.TicketFail,
  [GotchaStatusVo.WaitRedeemResult]: GotchaStatus.WaitRedeemResult,
  [GotchaStatusVo.Draw]: GotchaStatus.Draw,
  [GotchaStatusVo.Success]: GotchaStatus.Success,
  [GotchaStatusVo.UnknownApiStatus]: GotchaStatus.UnknownApiStatus,
};
